import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

const InfoToolTip = ({info}) => {
  console.log(info)
  return (
    <Tooltip 
      arrow
      placement="right"
      title={
        <div>
          <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
            Report Time Range: {info.TIME_RANGE} Days
          </Typography>
          <Typography
            variant="body2"
            sx={{ whiteSpace: "normal", lineHeight: 1.4 }}
          >
            <strong>Report Description:</strong> {info.REPORT_DESCRIPTION}
          </Typography>
        </div>
      }
      componentsProps={{
        tooltip: {
          sx: { 
            maxWidth: 300, 
            whiteSpace: "pre-line",
            backgroundColor: '#2c3e50',
            color: "white",
            p: 1.5,
            borderRadius: 1,
            boxShadow: 3, },
        },
      }}
    >
      <IconButton>
        <InfoOutlinedIcon fontSize="medium" color="primary" />
      </IconButton>
    </Tooltip>
  )
}

export default InfoToolTip